import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import { FiMenu, FiX } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Блокируем скролл страницы, пока открыто мобильное меню
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  const navLinks = [
    { name: 'Über uns', target: 'about' },
    { name: 'Methode', target: 'method' },
    { name: 'Portfolio', target: 'portfolio' },
    { name: 'Team', target: 'team' },
  ];

  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    setIsOpen(false);

    if (isHome) {
      // Если мы на главной, просто скроллим
      const element = document.getElementById(targetId);
      if (element) {
        const headerOffset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - headerOffset;
        window.scrollTo({ top: offsetPosition, behavior: "smooth" });
      }
    } else {
      // Если мы на другой странице, переходим на главную и передаем цель скролла в state
      navigate('/', { state: { scrollTo: targetId } });
    }
  };

  return (
    <>
    <header className={`fixed top-0 w-full z-50 transition-all duration-500 border-b ${
      scrolled ? 'bg-brand-bg/95 backdrop-blur-sm py-4 border-brand-text/10' : 'bg-transparent py-6 border-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 flex justify-between items-center">
        <Link 
          to="/" 
          onClick={(e) => {
            if (isHome) {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
            setIsOpen(false);
          }}
          className="relative z-50 flex items-center"
        >
          <img src="/images/logo/51north-logo.svg" alt="51North" className="h-7 w-auto" />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <button 
              key={link.name} 
              onClick={(e) => handleNavClick(e, link.target)}
              className="font-mono text-xs uppercase tracking-widest hover:text-brand-text/50 transition-colors cursor-pointer"
            >
              {link.name}
            </button>
          ))}
          <button 
            onClick={(e) => handleNavClick(e, 'contact')}
            className="relative group overflow-hidden border border-brand-text px-5 py-2.5 font-mono text-xs uppercase tracking-widest transition-colors cursor-pointer"
          >
            <span className="relative z-10 group-hover:text-brand-bg transition-colors duration-300">Kontakt</span>
            <div className="absolute inset-0 bg-brand-text translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out"></div>
          </button>
        </nav>

        {/* Mobile Toggle */}
        <button className="md:hidden relative z-50 p-2 text-brand-text" onClick={() => setIsOpen(!isOpen)}>
          <SafeIcon icon={isOpen ? FiX : FiMenu} className="text-2xl" />
        </button>
      </div>
    </header>

      {/* Mobile Menu — ВНЕ <header>: backdrop-blur шапки иначе ломает fixed-позиционирование оверлея */}
      <AnimatePresence>
          {isOpen && (
            <motion.div
              initial={{ y: '-100%' }}
              animate={{ y: 0 }}
              exit={{ y: '-100%' }}
              transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
              className="fixed inset-0 z-40 bg-brand-bg flex flex-col justify-center px-6 pt-20 pb-10 md:hidden border-b border-brand-text/10"
            >
              <div className="flex flex-col gap-4">
                {navLinks.map((link, i) => (
                  <motion.button
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2 + (i * 0.1) }}
                    key={link.name}
                    onClick={(e) => handleNavClick(e, link.target)}
                    className="font-archivo text-4xl uppercase border-b border-brand-text/10 pb-3 text-left"
                  >
                    {link.name}
                  </motion.button>
                ))}
                <motion.button
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.6 }}
                  onClick={(e) => handleNavClick(e, 'contact')}
                  className="mt-6 bg-brand-text text-brand-bg text-center py-5 font-mono text-sm uppercase tracking-widest"
                >
                  Projekt besprechen
                </motion.button>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
    </>
  );
};

export default Navbar;